"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/tags/index.ts
var tags_exports = {};
__export(tags_exports, {
  default: () => Tags_default
});
module.exports = __toCommonJS(tags_exports);
var import_index2 = require("./index.css");

// src/tags/Tags.tsx
var import_classnames4 = __toESM(require("classnames"));

// src/tags/_Tag.tsx
var import_react3 = require("react");

// src/closeButton/CloseButton.tsx
var import_classnames2 = __toESM(require("classnames"));

// src/fontAwesomeV6Icon/FontAwesomeV6Icon.tsx
var import_classnames = __toESM(require("classnames"));
var import_jsx_runtime = require("react/jsx-runtime");
var FontAwesomeV6Icon = ({
  iconStyle,
  iconFamily,
  iconName,
  className,
  title,
  animationType,
  ...HTMLAttributes4
}) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
  "i",
  {
    "data-testid": "font-awesome-v6-icon",
    className: (0, import_classnames.default)(
      iconFamily && `fa-${iconFamily}`,
      iconStyle && `fa-${iconStyle}`,
      iconName && `fa-${iconName}`,
      // Default icon style is solid, but only when no iconFamily prop is provided
      !iconFamily && !iconStyle && "fa-solid",
      animationType && `fa-${animationType}`,
      className
    ),
    title,
    ...HTMLAttributes4
  }
);
var FontAwesomeV6Icon_default = FontAwesomeV6Icon;

// src/closeButton/closeButton.module.scss
var closeButton_module_default = {
  "closeButton": "closeButton-module__closeButton___Ab4hh",
  "closeButton-dark": "closeButton-module__closeButton-dark___RqPRh",
  "closeButton-light": "closeButton-module__closeButton-light___UBkFK",
  "closeButton-l": "closeButton-module__closeButton-l___Gw8DM",
  "closeButton-m": "closeButton-module__closeButton-m___11tsA",
  "closeButton-s": "closeButton-module__closeButton-s___4zy5d",
  "closeButton-xs": "closeButton-module__closeButton-xs___bjImb"
};

// src/closeButton/CloseButton.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var CloseButton = ({
  onClick,
  size = "m",
  "aria-label": ariaLabel,
  color = "dark",
  id,
  className,
  ...HTMLAttributes4
}) => /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
  "button",
  {
    type: "button",
    id,
    "aria-label": ariaLabel,
    className: (0, import_classnames2.default)(
      closeButton_module_default.closeButton,
      closeButton_module_default[`closeButton-${color}`],
      closeButton_module_default[`closeButton-${size}`],
      className
    ),
    onClick,
    ...HTMLAttributes4,
    children: /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(FontAwesomeV6Icon_default, { iconName: "close" })
  }
);
var CloseButton_default = CloseButton;

// src/tooltip/index.ts
var import_index = require("./index.css");

// src/tooltip/_Tooltip.tsx
var import_classnames3 = __toESM(require("classnames"));
var import_react = require("react");

// src/tooltip/tooltip.module.scss
var tooltip_module_default = {
  "heading-xxl": "tooltip-module__heading-xxl___Wxave",
  "heading-xl": "tooltip-module__heading-xl___9SIFv",
  "heading-lg": "tooltip-module__heading-lg___pBoyG",
  "heading-md": "tooltip-module__heading-md___zYoPi",
  "heading-sm": "tooltip-module__heading-sm___h6LQC",
  "heading-xs": "tooltip-module__heading-xs___zF1vt",
  "body-one": "tooltip-module__body-one___kliHg",
  "body-two": "tooltip-module__body-two___zmg0f",
  "body-three": "tooltip-module__body-three___Huwkw",
  "body-four": "tooltip-module__body-four___YJRVJ",
  "overline-one": "tooltip-module__overline-one___ykjq0",
  "overline-two": "tooltip-module__overline-two___QcjzG",
  "overline-three": "tooltip-module__overline-three___fba7M",
  "strong": "tooltip-module__strong___531QW",
  "extra-strong": "tooltip-module__extra-strong___z3qHU",
  "em": "tooltip-module__em___9DUCL",
  "figcaption": "tooltip-module__figcaption___4dBW5",
  "tooltipOverlay": "tooltip-module__tooltipOverlay___I-rkD",
  "tooltip": "tooltip-module__tooltip___3zeep",
  "tooltipText": "tooltip-module__tooltipText___-H-vF",
  "tooltip-onTop": "tooltip-module__tooltip-onTop___WQLw1",
  "tooltip-onRight": "tooltip-module__tooltip-onRight___CBYB-",
  "tooltip-onBottom": "tooltip-module__tooltip-onBottom___zqQPq",
  "tooltip-onLeft": "tooltip-module__tooltip-onLeft___dXcgj",
  "tooltip-l": "tooltip-module__tooltip-l___YiC-j",
  "tooltip-m": "tooltip-module__tooltip-m___Yi8VT",
  "tooltip-s": "tooltip-module__tooltip-s___18FfP",
  "tooltip-xs": "tooltip-module__tooltip-xs___v4Wsu"
};

// src/tooltip/_Tooltip.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var TooltipOverlay = ({
  children,
  className
}) => /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("div", { className: (0, import_classnames3.default)(tooltip_module_default.tooltipOverlay, className), children });
var Tooltip = (0, import_react.forwardRef)(
  ({
    text,
    tooltipId,
    iconLeft,
    iconRight,
    direction = "onTop",
    className,
    size = "m",
    style = {},
    ...HTMLAttributes4
  }, ref) => {
    return /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)(
      "div",
      {
        ref,
        id: tooltipId,
        "aria-live": "polite",
        className: (0, import_classnames3.default)(
          tooltip_module_default.tooltip,
          tooltip_module_default[`tooltip-${direction}`],
          tooltip_module_default[`tooltip-${size}`],
          className
        ),
        style,
        role: "tooltip",
        ...HTMLAttributes4,
        children: [
          iconLeft && /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(FontAwesomeV6Icon_default, { ...iconLeft }),
          /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("span", { className: tooltip_module_default.tooltipText, children: text }),
          iconRight && /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(FontAwesomeV6Icon_default, { ...iconRight })
        ]
      }
    );
  }
);
var Tooltip_default = Tooltip;

// src/tooltip/WithTooltip.tsx
var import_react2 = require("react");
var import_react_dom = require("react-dom");

// src/common/helpers/index.ts
var calculatePositionedElementStyles = ({
  nodePosition,
  positionedElementRef,
  direction,
  tailOffset: tailOffset2,
  tailLength,
  isPositionFixed = false
}) => {
  const styles = {};
  if (nodePosition && positionedElementRef.current && direction !== "none") {
    const rect = nodePosition.getBoundingClientRect();
    const tooltipRect = positionedElementRef.current.getBoundingClientRect();
    const scrollY = isPositionFixed ? 0 : window.scrollY;
    const scrollX = isPositionFixed ? 0 : window.scrollX;
    const textDirection = document.documentElement.dir || "ltr";
    const isLtr = textDirection === "ltr";
    const verticalMiddlePosition = rect.top + scrollY + rect.height / 2 - tooltipRect.height / 2;
    const verticalTopPosition = rect.top + scrollY - tooltipRect.height - tailOffset2 - tailLength;
    const verticalBottomPosition = rect.top + rect.height + scrollY + tailOffset2 + tailLength;
    const horizontalMiddlePosition = rect.left + scrollX + rect.width / 2 - tooltipRect.width / 2;
    const horizontalLeftPosition = rect.left + scrollX - tooltipRect.width - tailOffset2 - tailLength;
    const horizontalRightPosition = rect.right + scrollX + tailOffset2 + tailLength;
    switch (direction) {
      case "onRight":
        styles.top = verticalMiddlePosition;
        styles.left = isLtr ? horizontalRightPosition : horizontalLeftPosition;
        break;
      case "onBottom":
        styles.top = verticalBottomPosition;
        styles.left = horizontalMiddlePosition;
        break;
      case "onLeft":
        styles.top = verticalMiddlePosition;
        styles.left = isLtr ? horizontalLeftPosition : horizontalRightPosition;
        break;
      case "onTop":
      default:
        styles.top = verticalTopPosition;
        styles.left = horizontalMiddlePosition;
        break;
    }
  }
  return styles;
};
var updatePositionedElementStyles = ({
  nodePosition,
  positionedElementRef,
  direction,
  setPositionedElementStyles,
  tailOffset: tailOffset2,
  tailLength,
  isPositionFixed = false
}) => {
  setPositionedElementStyles(
    calculatePositionedElementStyles({
      nodePosition,
      positionedElementRef,
      direction,
      tailOffset: tailOffset2,
      tailLength,
      isPositionFixed
    })
  );
};

// src/tooltip/WithTooltip.tsx
var import_jsx_runtime4 = require("react/jsx-runtime");
var tailOffset = 4;
var tailLengths = {
  l: 12,
  m: 9,
  s: 6,
  xs: 6
};
var WithTooltip = (0, import_react2.forwardRef)(
  ({ children, tooltipOverlayClassName, tooltipProps }, ref) => {
    const [nodePosition, setNodePosition] = (0, import_react2.useState)(null);
    const [showTooltip, setShowTooltip] = (0, import_react2.useState)(false);
    const [tooltipStyles, setTooltipStyles] = (0, import_react2.useState)({});
    const tooltipRef = (0, import_react2.useRef)(null);
    const hideTimeoutRef = (0, import_react2.useRef)(null);
    const suppressNextFocusRef = (0, import_react2.useRef)(false);
    const clearHideTimeout = () => {
      if (hideTimeoutRef.current) {
        clearTimeout(hideTimeoutRef.current);
        hideTimeoutRef.current = null;
      }
    };
    const handleShowTooltip = (show, event, isTooltip = false) => {
      if (suppressNextFocusRef.current && event.type === "focus") {
        suppressNextFocusRef.current = false;
        return;
      }
      setShowTooltip(show);
      clearHideTimeout();
      if (!isTooltip) {
        setNodePosition(show ? event.target : null);
      }
    };
    const handleHideTooltip = () => {
      hideTimeoutRef.current = window.setTimeout(() => {
        setShowTooltip(false);
        setNodePosition(null);
      }, 100);
    };
    (0, import_react2.useImperativeHandle)(ref, () => ({
      hideTooltip: () => {
        clearHideTimeout();
        setShowTooltip(false);
        setNodePosition(null);
        suppressNextFocusRef.current = true;
      }
    }));
    const tailLength = tailLengths[tooltipProps.size || "m"];
    const updateTooltipStyles = (0, import_react2.useCallback)(
      () => updatePositionedElementStyles({
        nodePosition,
        positionedElementRef: tooltipRef,
        direction: tooltipProps.direction,
        setPositionedElementStyles: setTooltipStyles,
        tailOffset,
        tailLength
      }),
      [nodePosition, tailLength, tooltipProps.direction]
    );
    (0, import_react2.useEffect)(() => {
      const updateTooltipPositionIfShown = () => {
        if (showTooltip) {
          updateTooltipStyles();
        }
      };
      updateTooltipPositionIfShown();
      window.addEventListener("resize", updateTooltipPositionIfShown);
      return () => {
        window.removeEventListener("resize", updateTooltipPositionIfShown);
      };
    }, [
      showTooltip,
      nodePosition,
      tooltipProps.direction,
      tailLength,
      updateTooltipStyles
    ]);
    (0, import_react2.useEffect)(() => {
      const handleKeyDown = (event) => {
        if (event.key === "Escape") {
          handleHideTooltip();
        }
      };
      if (showTooltip) {
        document.addEventListener("keydown", handleKeyDown);
      }
      return () => {
        document.removeEventListener("keydown", handleKeyDown);
      };
    }, [showTooltip]);
    const tooltipStyleProps = {
      visibility: showTooltip ? "visible" : "hidden",
      ...tooltipStyles
    };
    const componentToWrap = (0, import_react2.isValidElement)(children) && (0, import_react2.cloneElement)(children, {
      "aria-describedby": tooltipProps.tooltipId,
      onFocus: (event) => {
        var _a, _b;
        handleShowTooltip(true, event);
        (_b = (_a = children.props).onFocus) == null ? void 0 : _b.call(_a, event);
      },
      onBlur: (event) => {
        var _a, _b;
        handleHideTooltip();
        (_b = (_a = children.props).onBlur) == null ? void 0 : _b.call(_a, event);
      },
      onMouseEnter: (event) => {
        var _a, _b;
        handleShowTooltip(true, event);
        (_b = (_a = children.props).onMouseEnter) == null ? void 0 : _b.call(_a, event);
      },
      onMouseLeave: (event) => {
        var _a, _b;
        handleHideTooltip();
        (_b = (_a = children.props).onMouseLeave) == null ? void 0 : _b.call(_a, event);
      }
    });
    return /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)(TooltipOverlay, { className: tooltipOverlayClassName, children: [
      componentToWrap,
      showTooltip && (0, import_react_dom.createPortal)(
        /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
          Tooltip_default,
          {
            ...tooltipProps,
            ref: tooltipRef,
            style: tooltipStyleProps,
            onMouseEnter: (event) => handleShowTooltip(true, event, true),
            onMouseLeave: handleHideTooltip
          }
        ),
        document.body
      )
    ] });
  }
);
var WithTooltip_default = WithTooltip;

// src/tags/tags.module.scss
var tags_module_default = {
  "heading-xxl": "tags-module__heading-xxl___wqhpF",
  "heading-xl": "tags-module__heading-xl___4aYfC",
  "heading-lg": "tags-module__heading-lg___ZmwhK",
  "heading-md": "tags-module__heading-md___duAM0",
  "heading-sm": "tags-module__heading-sm___7EPqo",
  "heading-xs": "tags-module__heading-xs___bm0lY",
  "body-one": "tags-module__body-one___KFqKP",
  "body-two": "tags-module__body-two___sdp-A",
  "body-three": "tags-module__body-three___2JF2p",
  "body-four": "tags-module__body-four___I9sJk",
  "overline-one": "tags-module__overline-one___pW5Mn",
  "overline-two": "tags-module__overline-two___G-1Kx",
  "overline-three": "tags-module__overline-three___rUICV",
  "strong": "tags-module__strong___0bGpH",
  "extra-strong": "tags-module__extra-strong___dNRGd",
  "em": "tags-module__em___cb-Ts",
  "figcaption": "tags-module__figcaption___OAQbJ",
  "tags": "tags-module__tags___qLMsX",
  "tag": "tags-module__tag___cgocf",
  "tags-l": "tags-module__tags-l___Vbf1P",
  "tags-m": "tags-module__tags-m___3Vr7N",
  "tags-s": "tags-module__tags-s___kdKcg"
};

// src/tags/_Tag.tsx
var import_jsx_runtime5 = require("react/jsx-runtime");
var TagIcon = (0, import_react3.memo)(({ iconName, iconStyle, title }) => /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(FontAwesomeV6Icon_default, { iconName, iconStyle, title }));
var Tag = (props) => {
  const {
    label,
    ariaLabel,
    tooltipContent,
    tooltipId,
    icon,
    type = "default"
  } = props;
  const tooltipWrapper = (0, import_react3.useCallback)(
    (children) => tooltipContent && tooltipId ? /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
      WithTooltip_default,
      {
        tooltipProps: {
          direction: "onTop",
          text: tooltipContent,
          tooltipId
        },
        children
      }
    ) : children,
    [tooltipContent, tooltipId]
  );
  const containerAttrs = {
    className: tags_module_default.tag,
    tabIndex: 0,
    "aria-label": ariaLabel,
    "aria-describedby": tooltipContent && tooltipId ? tooltipId : void 0
  };
  if (type === "closable") {
    delete containerAttrs.tabIndex;
    const { onClose } = props;
    return tooltipWrapper(
      /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)("div", { ...containerAttrs, children: [
        /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("span", { children: label }),
        /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
          CloseButton_default,
          {
            onClick: onClose,
            "aria-label": `Close ${ariaLabel != null ? ariaLabel : label}`
          }
        )
      ] })
    );
  }
  if (type === "default") {
    return tooltipWrapper(
      /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)("div", { ...containerAttrs, children: [
        icon && icon.placement === "left" && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(TagIcon, { ...icon }),
        /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("span", { children: label }),
        icon && icon.placement === "right" && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(TagIcon, { ...icon })
      ] })
    );
  }
};
var Tag_default = (0, import_react3.memo)(Tag);

// src/tags/Tags.tsx
var import_jsx_runtime6 = require("react/jsx-runtime");
var Tags = ({
  tagsList,
  size = "m",
  className
}) => /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(
  "div",
  {
    className: (0, import_classnames4.default)(
      tags_module_default.tags,
      tags_module_default[`tags-${size}`],
      className
    ),
    "data-testid": "tags",
    children: tagsList.map(
      ({ key, tooltipId, label, tooltipContent, ariaLabel, icon, ...props }) => {
        var _a;
        return /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(
          Tag_default,
          {
            tooltipId,
            label,
            ariaLabel,
            icon,
            tooltipContent,
            ...props
          },
          (_a = key != null ? key : tooltipId) != null ? _a : label
        );
      }
    )
  }
);
var Tags_default = Tags;
//# sourceMappingURL=index.js.map